// extracted by mini-css-extract-plugin
export default {"blue":"OneOrGroup_blue__-fi46"};